module.exports = __webpack_public_path__ + "img/img86.ad2c90f5.jpg";